module.exports = __webpack_public_path__ + "img/partner_img28.ecb41b0c.png";